import { useLang } from 'hooks/lang';

import { Button, Column } from 'components/Blocks';
import { EntityLoader } from 'components/Entities';

import { ArrowRightIcon } from 'components/Icons';

import { LoadingBalances } from './LoadingBalance';
import { BalanceOverview } from './BalanceOverview';

export function ClientBalances(): JSX.Element {
  const { t } = useLang();

  return (
    <Column>
      <h6 className="text-xl font-semibold text-primary"> {t('open-clients-balances')}</h6>

      <EntityLoader target="clients.balanceOverview" loading={<LoadingBalances />}>
        {({ data }) => (
          <Column alignItems="center">
            <BalanceOverview data={data} />

            <Button to="clientsBalance" variant="ghost">
              <span className="text-sm font-medium">{t('access-balances')}</span>

              <ArrowRightIcon color="primary" />
            </Button>
          </Column>
        )}
      </EntityLoader>
    </Column>
  );
}
